import React from 'react';
import { cn } from '../../lib/utils';

export function PrivacyNote({ className }) {
  return (
    <p className={cn('text-[11px] text-slate-400', className)}>
      No PII in v1. Individual journeys (if added later) would use anonymised ids only.
    </p>
  );
}
